import type {StateProvider} from '@uirouter/angularjs';
import FiltersController from './filters.controller';

/*@ngInject*/
export default function filtersRoutes($stateProvider: StateProvider) {
    $stateProvider
        .state({
            name: 'filters',
            url: '/filters',
            templateUrl: require('./filters.tpl.ftl'),
            controller: FiltersController,
            controllerAs: '$ctrl',
        });
}